'use client'

import { Img } from 'components/basic/Img'
import { Button } from 'components/Phantom/Button'
import { usePathname, useSearchParams } from 'next/navigation'
import styles from 'pagestyles/article.module.scss'
import { FC } from 'react'

export const CTASection: FC = () => {
	const pathname = usePathname() ?? ''
	const searchParams = useSearchParams()
	if (searchParams?.get('utm_source') === 'app') {
		return null
	}

	return (
		<>
			<section className={`bg-white inner-paddings-bottom tac`}>
				<Button.Dark
					id={'cta_pod'}
					href={pathname.includes('sleep-elixir') ? '/product/sleep-elixir/' : '/product/pod-cover/'}
				>
					{pathname.includes('sleep-elixir') ? 'Get Sleep Elixir now' : 'Shop the Pod'}
				</Button.Dark>
			</section>
			<section className={`inner-paddings-x inner-paddings-y bg-grey ${styles.cta_section}`}>
				<div>
					<h3>Upgrade your sleep with Eight Sleep's cooling technology</h3>
					<Button.Dark
						id={'cta_pod_2'}
						href="/pod-cover/"
					>
						Learn more
					</Button.Dark>
				</div>
				<div>
					<Img
						src="https://eight-eightsleep-react.s3.us-east-2.amazonaws.com/assets/new_blog_cta_pod4.png"
						alt="Pod 4"
					/>
				</div>
			</section>
		</>
	)
}
